import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BaseService } from './base.service';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSource = new Subject();
  usersource$ = this.userSource.asObservable();
  isLoggedIn: boolean;
  redirectUrl: string;
  user: User;

  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService,
    private router: Router
  ) {}

  logout(): void {
    const url = `${this.baseService.hostDomain}/api/logout`;
    this.httpClient
      .post(url, null)
      .pipe(
        catchError(err => {
          this.baseService.handleError(
            err,
            'Cerrando sesión información de usuario.'
          );
          return [];
        })
      )
      .subscribe(() => {
        this.isLoggedIn = false;
        this.user = null;
        this.router.navigate(['/salir']);
      });
  }

  getUser(): Observable<User> {
    const url = `${this.baseService.hostDomain}/api/user`;
    return this.httpClient.get<User>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Obteniendo información de usuario.');
        return [];
      })
    );
  }

}
